import { PreFlight } from 'pupdocs/types';
import { FacetList, TableFilter } from 'types';
import { defaultSort } from 'utilities/sorts/sorts';

export interface PreFlightsState {
  loading: boolean;
  preFlights: PreFlight[];
  facets: FacetList;
  filters: TableFilter;
}

export const metaStatus = {
  urgent: 'isUrgent',
  pending: 'isPendingReview',
  review: 'isInReview',
  empty: 'isEmpty',
  finalized: 'isFinalized',
};

export type MetaStatusString =
  | 'isUrgent'
  | 'isPendingReview'
  | 'isInReview'
  | 'isEmpty'
  | 'isFinalized';

export const preFlightInitialState: PreFlightsState = {
  loading: false,
  preFlights: [],
  facets: {},
  filters: {},
};

export const filterByMetaStatus = (
  item: PreFlight,
  status: MetaStatusString,
): boolean => {
  return (item.meta && item.meta[status] === true) ?? false;
};

export type PreFlightsAction =
  | { type: 'LOAD_PRE_FLIGHTS' }
  | { type: 'SET_PRE_FLIGHTS'; payload: { preFlights: PreFlight[]; facets: FacetList } }
  | { type: 'FILTER_PRE_FLIGHTS'; payload: TableFilter }
  | { type: 'FILTER_PRE_FLIGHTS_META_STATUS'; payload: { metaStatus: MetaStatusString } };

export const preFlightReducer = (
  state: PreFlightsState,
  action: PreFlightsAction,
): PreFlightsState => {
  switch (action.type) {
    case 'LOAD_PRE_FLIGHTS': {
      return { ...state, loading: true };
    }
    case 'FILTER_PRE_FLIGHTS': {
      const filters = { ...action.payload };

      return { ...state, filters };
    }
    case 'SET_PRE_FLIGHTS': {
      const { facets, preFlights } = action.payload;

      preFlights.sort((preFlightA, preFlightB) =>
        defaultSort(preFlightB.id, preFlightA.id),
      );

      return {
        ...state,
        loading: false,
        preFlights,
        facets,
      };
    }
    case 'FILTER_PRE_FLIGHTS_META_STATUS': {
      const { metaStatus } = action.payload;
      const clonedPreflight = Object.assign([], state.preFlights);
      const filteredPreFlights = clonedPreflight.filter((preflight) =>
        filterByMetaStatus(preflight, metaStatus),
      );

      return { ...state, preFlights: filteredPreFlights };
    }
    default:
      return state;
  }
};
